export default "__VITE_ASSET__8b74dcfb__"